export enum TileType {
  None,
  ProductTile,
  ProductContentTile,
  CategoryTile,
}
